var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJournalIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 12H4C3.63181 12 3.33333 12.2985 3.33333 12.6667C3.33333 13.0349 3.63181 13.3333 4 13.3333H14V14.6667H4C2.89543 14.6667 2 13.7713 2 12.6667V2.66667C2 1.93029 2.59695 1.33333 3.33333 1.33333H14V12ZM3.33333 10.7C3.44104 10.6781 3.55251 10.6667 3.66667 10.6667H12.6667V2.66667H3.33333V10.7ZM10.6667 6H5.33333V4.66667H10.6667V6Z",
    fill: "#111822"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJournalIcon);
export default __webpack_public_path__ + "static/media/journalIcon.4ea705f7.svg";
export { ForwardRef as ReactComponent };